import { useCallback, useEffect } from 'react';
import { useRoleByIdQuery } from 'api';
import { ADMIN_ROUTES } from 'constants/routes';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { ErrorMappingValueType } from 'typings';
import { useNotificationApi } from 'hooks/useNotificationApi';

export const usePermissions = () => {
  const { id } = useParams() as { id: string };

  const navigate = useNavigate();
  const location = useLocation();
  const notificationApi = useNotificationApi();
  const { data = {} } = useRoleByIdQuery({ id });

  const onUpdateClick = useCallback(() => {
    navigate(`${ADMIN_ROUTES.role.update}/${id}`);
  }, [navigate, id]);

  useEffect(() => {
    if (location.state?.notification) {
      const { type, message }: ErrorMappingValueType = location.state.notification;
      notificationApi({ type, message });
      navigate(location.pathname, { replace: true, state: {} });
    }
  }, [location, notificationApi, navigate]);

  return {
    data,
    onUpdateClick,
  };
};
